export const FETCH_WEEKLY_SALES_SUCCESS = "FETCH_WEEKLY_SALES_SUCCESS";
export const FETCH_WEEKLY_SALES_FAILURE = "FETCH_WEEKLY_SALES_FAILURE";
export const FETCH_WEEKLY_ORDERS_SUCCESS = "FETCH_WEEKLY_ORDERS_SUCCESS";
export const FETCH_WEEKLY_ORDERS_FAILURE = "FETCH_WEEKLY_ORDERS_FAILURE";
export const FETCH_VISITORS_ONLINE_SUCCESS = "FETCH_VISITORS_ONLINE_SUCCESS";
export const FETCH_VISITORS_ONLINE_FAILURE = "FETCH_VISITORS_ONLINE_FAILURE";
